<!--
 * @Author: Gaho
 * @Date: 2024-01-12 13:35:50
 * @LastEditors: Merlin
 * @LastEditTime: 2024-10-15 17:08:40
 * @Description: 目前仅用于 Waves 游戏 
-->

<template>
    <!-- ↓ 押注（币种图标） -->
    <CasinoHistoryHeaderCell
        :text="$tFn('waves.Bet').toUpperCase()"
        class="flex-[0.3]"
    />
    <!-- ↓ 总押注 -->
    <!-- <CasinoHistoryHeaderCell
        class="flex-[0.4]"
        :text="$tFn('waves.calc_Wager').toUpperCase()"
    /> -->
    <!-- ↓ 入场价格 -->
    <!-- <CasinoHistoryHeaderCell
        :text="$tFn('waves.calc_EntryPrice').toUpperCase()"
        class="flex-[0.5]"
    /> -->
    <!-- ↓ 爆仓价格，  -->
    <!-- <CasinoHistoryHeaderCell
        :text="$tFn('waves.calc_BustPrice').toUpperCase()"
        class="flex-[0.5]"
    /> -->
    <!-- ↓ 资金费率／每小时-->
    <!-- <CasinoHistoryHeaderCell
        :text="$tFn('waves.FundingH').toUpperCase()"
        class="flex-[0.4]"
    /> -->
    <!-- ↓ P&L, ROI -->
    <CasinoHistoryHeaderCell
        class="flex-[0.5]" 
        :text="$tFn('waves.calc_PL_ROI').toUpperCase()"
    />
    <CasinoHistoryHeaderCell
        class="flex-[0.7] pr-1" 
        text=" "
    />
</template>

<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
import { HistoryTabsEnum } from '@/components/Casino/History/Tabs/ts/Tabs';

const {t: $tFn} = useNuxtApp().$i18n;
const t = useTranslation();
const props = defineProps({
    isMobileMode: Boolean, // 声明出来，否则控制台一直打印 warn 信息 
    tabName: {
        type: String as PropType<HistoryTabsEnum>, 
    },
});


</script>
